import {
  ADD_TO_COMPARE,
  CLEAR_COMPARE,
  REMOVE_FROM_COMPARE,
  SET_COMPARE,
  CompareAction,
  CompareState,
  initialState,
} from "./types";

export const compareReducer = (
  state: CompareState,
  action: CompareAction
): CompareState => {

  switch (action.type) {

    case ADD_TO_COMPARE: {
      const { audience, index } = action.payload;
      const audiences = state.comparisonAudiences;
      if (audiences.some((a) => a.audience_id === audience.audience_id)) return state;

      // Insert at the given index if provided, otherwise at the end
      const at = index === undefined
        ? audiences.length
        : Math.min(Math.max(index, 0), audiences.length);

      return {
        ...state,
        comparisonAudiences: [...audiences.slice(0, at), audience, ...audiences.slice(at)],
      };
    }

    case SET_COMPARE:
      return { ...state, comparisonAudiences: action.payload };

    case REMOVE_FROM_COMPARE: {
      const audiences = state.comparisonAudiences.filter(
        (audience) => audience.audience_id !== action.payload.audience_id
      );
      if (audiences.length === state.comparisonAudiences.length) return state;
      return { ...state, comparisonAudiences: audiences };
    }

    case CLEAR_COMPARE:
      return state.comparisonAudiences.length === 0 ? state : initialState;

    default:
      return state;
  }
};
